import { render, staticRenderFns } from "./ConfigHolidayDates.vue?vue&type=template&id=4c86b766&scoped=true"
import script from "./ConfigHolidayDates.vue?vue&type=script&lang=js"
export * from "./ConfigHolidayDates.vue?vue&type=script&lang=js"
import style0 from "./ConfigHolidayDates.vue?vue&type=style&index=0&id=4c86b766&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c86b766",
  null
  
)

export default component.exports